<template>
  <div class="tip-div">
    <div
      class="tortBrand-wrap"
      v-if="detail.brands && detail.brands[isLabel ? 99 : language] && detail.brands[isLabel ? 99 : language].length"
    >
      <div class="tortBrandT">风险词:</div>
      <div class="tortBrandList" v-for="(it, i) in detail.brands[isLabel ? 99 : language]" :key="i">
        <div class="urlBox" v-if="it.oss_file_url">
          <img :src="it.oss_file_url" :title="it.name" />
        </div>
        <div class="tortBrandInfo">
          <span>
            <template v-if="it.level === 1">
              <img src="@/assets/icons/lowLevel.png" title="有风险" />
            </template>
            <template v-else-if="it.level === 2">
              <img src="@/assets/icons/mLevel.png" title="中风险" />
            </template>
            <template v-else>
              <img src="@/assets/icons/hLevel.png" title="高风险" />
            </template>
          </span>
          <span>{{ it.name }}</span>
          <span v-if="it.remark">备注: {{ it.remark }}</span>
        </div>
      </div>
    </div>
    <div
      class="tortBrand-wrap"
      v-if="detail.risks && detail.risks[isLabel ? 99 : language] && detail.risks[isLabel ? 99 : language].length"
    >
      <div class="tortBrandT">系统风险词:</div>
      <div class="tortBrandList" v-for="(it, i) in detail.risks[isLabel ? 99 : language]" :key="i">
        <div class="urlBox" v-if="it.oss_file_url">
          <img :src="it.oss_file_url" :title="it.name" />
        </div>
        <div class="tortBrandInfo">
          <span>
            <template v-if="it.level === 1">
              <img src="@/assets/icons/lowLevel.png" title="有风险" />
            </template>
            <template v-else-if="it.level === 2">
              <img src="@/assets/icons/mLevel.png" title="中风险" />
            </template>
            <template v-else>
              <img src="@/assets/icons/hLevel.png" title="高风险" />
            </template>
          </span>
          <span>{{ it.name }}</span>
          <span v-if="it.remark">备注: {{ it.remark }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  props: ['detail', 'language', 'isLabel'],
  name: 'TortBrandList',
  methods: {},
  computed: {},
  mounted() {}
}
</script>
<style scoped lang="less"></style>
